<template>
  <div id="chart">
    <apexchart type="line" height="250" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
// import Dashboard from '../../store/modules/dashboard/moduleDashboard'
// import { dateFormat } from '@/utility/utility'
import { mapGetters } from 'vuex'
import { EventBus } from '@/EventBus'
export default {
  data: () => ({
    series: [],
    data: [],
    // series: [
    //     {
    //       name:'total',
    //       data:[4,5,1,4,5,1,4,5,1,4,5,1,4,5,1,4,5,1]
    //     },
    //     {
    //       name:'Success',
    //       data:[3,0,1,10,9,14,5,3,0,4,2,3,7,6,12]
    //     },
    //     {
    //       name:'Fail',
    //       data:[1,5,0,2,4,2,5,3,1,6,5,0,5,4,3,4]
    //     }
    //   ],
    chartOptions: {},
    DateTo: ''
  }),
  computed: {
    ...mapGetters(['dataSummaryLog'])
  },
  methods: {
    getDateFormat () {
      const [yearTo, monthTo] = this.DateTo.split('-')
      const dateto = 1 + '-' + monthTo + '-' + yearTo
      return dateto
    },
    async getDataChart () {
      this.series = []
      // console.log(this.data.series)
      this.data.series.forEach((element) => {
        // console.log(element)
        const data = {
          name: element.name,
          data: element.data
        }
        this.series.push(data)
      })
    },
    getChartOptions (data) {
      this.chartOptions = {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: []
            },
            export: {
              csv: {
                filename: "export_TSA",
              },
              svg: {
                filename: "export_TSA",
              },
              png: {
                filename: "export_TSA",
              }
            },
            autoSelected: 'zoom' 
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [5, 7, 5],
          curve: 'straight',
          dashArray: [0, 8, 5]
        },
        title: {
          text: 'Graph ToTal TSA',
          align: 'center'
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex].toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ''
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Set decimal format to 2 decimal places
            }
          },
          title: {
            text: 'Transaction',
            align: 'center'
          }
        },
        xaxis: {
          categories: data.xaxis.catagories
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + ' (mins)'
                }
              }
            },
            {
              title: {
                formatter: function (val) {
                  return val + ' per session'
                }
              }
            },
            {
              title: {
                formatter: function (val) {
                  return val
                }
              }
            }
          ]
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      }
    },
    getDateFromDashboard (data) {
      // console.log('data', data)
      this.data = data
      this.getDataChart()
      this.getChartOptions(this.data)
    }
  },
  mounted () {
    EventBus.$on('dashboradDataLineCusGroup', this.getDateFromDashboard)
  },
  beforeDestroy () {
    EventBus.$off('dashboradDataLineCusGroup')
  }
}
</script>

<style lang="scss" scoped>
.card-chart {
  display: flex;
  height: 20rem;
  // margin-left: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  justify-content: center;
  // align-items: center;
  flex-direction: column;
}
.card-container {
  display: flex;
  height: 10rem;
  // margin-left: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  justify-content: center;
  // align-items: center;
  flex-direction: column;
}

.text-sub {
  // margin-top: 21px;
  font-size: 18px;
  text-align: center;
    // margin-bottom: 10%;

}

.icon-color-1 {
  margin-left: 5%;
  font-size: 5em ;
  color:#47B99D !important;

}

</style>
